import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field']
  static values = {
    max: { type: Number, default: Infinity },
    min: { type: Number, default: -Infinity }
  }

  increment() {
    let value = parseInt(this.fieldTarget.value) + 1
    if (value <= this.maxValue) {
      this.fieldTarget.value = value
    }
  }

  decrement() {
    let value = parseInt(this.fieldTarget.value) - 1
    if (value >= this.minValue) {
      this.fieldTarget.value = value
    }
  }
}